import { props, createAction } from '@ngrx/store'
import { Rate } from './rate.model'

export const LoadGroupRatesComplete = createAction('[Group Rates] Load Complete', props<{ rates: Rate[] }>())
export const GroupRatesChangedComplete = createAction(
  '[Group Rates] Group Rates Changed Complete',
  props<{ rates: Rate[]; isRentalDeleted?: boolean }>()
)
export const RatesChangedComplete = createAction('[Group Rates] Rates Changed Complete', props<{ rentalId: string }>())
